var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -3.33325,
    y: -0.555664,
    width: 31.1111,
    height: 22.2222,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1084_91181",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -1,
    width: 32,
    height: 23
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -3.33325,
    y: -0.555664,
    width: 31.1111,
    height: 22.2222,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1084_91181)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7779 -0.555664H-3.33325V0.925817H27.7779V-0.555664ZM27.7779 2.4073H-3.33325V3.88878H27.7779V2.4073ZM-3.33325 5.37026H27.7779V6.85174H-3.33325V5.37026ZM27.7779 8.33322H-3.33325V9.81471H27.7779V8.33322ZM-3.33325 11.2962H27.7779V12.7777H-3.33325V11.2962ZM27.7779 14.2591H-3.33325V15.7406H27.7779V14.2591ZM-3.33325 17.2221H27.7779V18.7036H-3.33325V17.2221ZM27.7779 20.1851H-3.33325V21.6666H27.7779V20.1851Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.33325,
    y: -0.555664,
    width: 13.3333,
    height: 10.3704,
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1084_91181)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.370325 1.66652C-0.370325 2.07562 -0.701966 2.40726 -1.11107 2.40726C-1.52017 2.40726 -1.85181 2.07562 -1.85181 1.66652C-1.85181 1.25742 -1.52017 0.925781 -1.11107 0.925781C-0.701966 0.925781 -0.370325 1.25742 -0.370325 1.66652ZM2.59264 1.66652C2.59264 2.07562 2.261 2.40726 1.8519 2.40726C1.4428 2.40726 1.11116 2.07562 1.11116 1.66652C1.11116 1.25742 1.4428 0.925781 1.8519 0.925781C2.261 0.925781 2.59264 1.25742 2.59264 1.66652ZM4.81486 2.40726C5.22396 2.40726 5.5556 2.07562 5.5556 1.66652C5.5556 1.25742 5.22396 0.925781 4.81486 0.925781C4.40576 0.925781 4.07412 1.25742 4.07412 1.66652C4.07412 2.07562 4.40576 2.40726 4.81486 2.40726ZM8.51856 1.66652C8.51856 2.07562 8.18692 2.40726 7.77782 2.40726C7.36872 2.40726 7.03708 2.07562 7.03708 1.66652C7.03708 1.25742 7.36872 0.925781 7.77782 0.925781C8.18692 0.925781 8.51856 1.25742 8.51856 1.66652ZM0.370416 3.88874C0.779516 3.88874 1.11116 3.5571 1.11116 3.148C1.11116 2.7389 0.779516 2.40726 0.370416 2.40726C-0.0386841 2.40726 -0.370325 2.7389 -0.370325 3.148C-0.370325 3.5571 -0.0386841 3.88874 0.370416 3.88874ZM4.07412 3.148C4.07412 3.5571 3.74248 3.88874 3.33338 3.88874C2.92428 3.88874 2.59264 3.5571 2.59264 3.148C2.59264 2.7389 2.92428 2.40726 3.33338 2.40726C3.74248 2.40726 4.07412 2.7389 4.07412 3.148ZM6.29634 3.88874C6.70544 3.88874 7.03708 3.5571 7.03708 3.148C7.03708 2.7389 6.70544 2.40726 6.29634 2.40726C5.88724 2.40726 5.5556 2.7389 5.5556 3.148C5.5556 3.5571 5.88724 3.88874 6.29634 3.88874ZM8.51856 4.62948C8.51856 5.03858 8.18692 5.37023 7.77782 5.37023C7.36872 5.37023 7.03708 5.03858 7.03708 4.62948C7.03708 4.22039 7.36872 3.88874 7.77782 3.88874C8.18692 3.88874 8.51856 4.22039 8.51856 4.62948ZM4.81486 5.37023C5.22396 5.37023 5.5556 5.03858 5.5556 4.62948C5.5556 4.22039 5.22396 3.88874 4.81486 3.88874C4.40576 3.88874 4.07412 4.22039 4.07412 4.62948C4.07412 5.03858 4.40576 5.37023 4.81486 5.37023ZM2.59264 4.62948C2.59264 5.03858 2.261 5.37023 1.8519 5.37023C1.4428 5.37023 1.11116 5.03858 1.11116 4.62948C1.11116 4.22039 1.4428 3.88874 1.8519 3.88874C2.261 3.88874 2.59264 4.22039 2.59264 4.62948ZM-1.11107 5.37023C-0.701966 5.37023 -0.370325 5.03858 -0.370325 4.62948C-0.370325 4.22039 -0.701966 3.88874 -1.11107 3.88874C-1.52017 3.88874 -1.85181 4.22039 -1.85181 4.62948C-1.85181 5.03858 -1.52017 5.37023 -1.11107 5.37023ZM1.11116 6.11097C1.11116 6.52007 0.779516 6.85171 0.370416 6.85171C-0.0386841 6.85171 -0.370325 6.52007 -0.370325 6.11097C-0.370325 5.70187 -0.0386841 5.37023 0.370416 5.37023C0.779516 5.37023 1.11116 5.70187 1.11116 6.11097ZM3.33338 6.85171C3.74248 6.85171 4.07412 6.52007 4.07412 6.11097C4.07412 5.70187 3.74248 5.37023 3.33338 5.37023C2.92428 5.37023 2.59264 5.70187 2.59264 6.11097C2.59264 6.52007 2.92428 6.85171 3.33338 6.85171ZM7.03708 6.11097C7.03708 6.52007 6.70544 6.85171 6.29634 6.85171C5.88724 6.85171 5.5556 6.52007 5.5556 6.11097C5.5556 5.70187 5.88724 5.37023 6.29634 5.37023C6.70544 5.37023 7.03708 5.70187 7.03708 6.11097ZM7.77782 8.33319C8.18692 8.33319 8.51856 8.00155 8.51856 7.59245C8.51856 7.18335 8.18692 6.85171 7.77782 6.85171C7.36872 6.85171 7.03708 7.18335 7.03708 7.59245C7.03708 8.00155 7.36872 8.33319 7.77782 8.33319ZM5.5556 7.59245C5.5556 8.00155 5.22396 8.33319 4.81486 8.33319C4.40576 8.33319 4.07412 8.00155 4.07412 7.59245C4.07412 7.18335 4.40576 6.85171 4.81486 6.85171C5.22396 6.85171 5.5556 7.18335 5.5556 7.59245ZM1.8519 8.33319C2.261 8.33319 2.59264 8.00155 2.59264 7.59245C2.59264 7.18335 2.261 6.85171 1.8519 6.85171C1.4428 6.85171 1.11116 7.18335 1.11116 7.59245C1.11116 8.00155 1.4428 8.33319 1.8519 8.33319ZM-0.370325 7.59245C-0.370325 8.00155 -0.701966 8.33319 -1.11107 8.33319C-1.52017 8.33319 -1.85181 8.00155 -1.85181 7.59245C-1.85181 7.18335 -1.52017 6.85171 -1.11107 6.85171C-0.701966 6.85171 -0.370325 7.18335 -0.370325 7.59245Z",
    fill: "url(#paint0_linear_1084_91181)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1084_91181",
    x: -1.85181,
    y: 0.925781,
    width: 10.3704,
    height: 8.40747,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1084_91181"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1084_91181",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1084_91181",
    x1: -1.85181,
    y1: 0.925781,
    x2: -1.85181,
    y2: 8.33319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.454b278bdc330f0e9ab84cb63c40ce6c.svg";
export { ForwardRef as ReactComponent };